<template>
  <base-modal
    v-if="showModal"
    :required="!!feedback"
    @modalState="closeWithoutAnswer"
    class="modal-convincing-deactivating-list"
  >
    <template v-slot:content>
      <HelpUsToImprove v-if="!feedback" @selected="changeFeedback" />
      <PreferProducts
        v-else-if="feedback.type === 'prefiro_produtos'"
        @keepList="closeAndKeepList"
        @disableList="closeAndDisable"
      />
      <ActivateInTheFuture
        v-else-if="feedback.type === 'vou_ativar_futuramente'"
        @keepList="closeAndKeepList"
        @disableList="closeAndDisable"
      />
      <DontUnderstandHowWorks
        v-else-if="feedback.type === 'nao_entendi_como_funciona'"
        @keepList="closeAndKeepList"
        @disableList="closeAndDisable"
      />
      <HardToEdit
        v-else-if="feedback.type === 'achei_dificil_montar'"
        @keepList="closeAndKeepList"
        @disableList="closeAndDisable"
      />
      <VeryHighTaxe
        v-else-if="feedback.type === 'taxa_muito_alta'"
        @keepList="closeAndKeepList"
        @disableList="closeAndDisable"
      />
      <DontWantPaypal
        v-else-if="feedback.type === 'nao_quero_paypal'"
        @keepList="closeAndKeepList"
        @disableList="closeAndDisable"
      />
    </template>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import GiftsApi from '@/lib/api/Gifts'

import BaseModal from '@/components/BaseModal.vue'
import HelpUsToImprove from './HelpUsToImprove.vue'
import PreferProducts from './PreferProducts.vue'
import ActivateInTheFuture from './ActivateInTheFuture.vue'
import DontUnderstandHowWorks from './DontUnderstandHowWorks.vue'
import HardToEdit from './HardToEdit.vue'
import VeryHighTaxe from './VeryHighTaxe.vue'
import DontWantPaypal from './DontWantPaypal.vue'

export default {
  components: {
    BaseModal,
    HelpUsToImprove,
    PreferProducts,
    ActivateInTheFuture,
    DontUnderstandHowWorks,
    HardToEdit,
    VeryHighTaxe,
    DontWantPaypal,
  },

  data() {
    return {
      showModal: false,
      feedback: undefined,
      survey: {
        type: 'desativar_lista',
        answer: undefined,
      },
    }
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
    }),
  },

  methods: {
    async open(published) {
      if (published) this.dispatchConfirmation()
      else {
        const answered = await this.getSurveyAnswered()
        if (!answered) this.showModal = true
        else this.dispatchConfirmation()
      }
    },

    changeFeedback(feedback) {
      this.feedback = feedback
    },

    closeModal() {
      this.showModal = false
    },

    dispatchConfirmation() {
      this.$emit('confirmed')
    },

    dispatchKeep() {
      this.$emit('keep')
    },

    closeWithoutAnswer() {
      this.survey.answer = 'nao_quero_responder'
      this.saveSurvey()
      this.dispatchConfirmation()
      this.closeModal()
    },

    closeAndKeepList() {
      this.survey.answer = 'quero_manter_lista'
      this.saveSurvey()
      this.dispatchKeep()
      this.closeModal()
    },

    closeAndDisable() {
      this.survey.answer = this.feedback.type
      this.saveSurvey()
      this.dispatchConfirmation()
      this.closeModal()
    },

    async saveSurvey() {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.saveGiftsListsSurvey({
        tipo: this.survey.type,
        resposta: this.survey.answer,
      })
    },

    getSurveyAnswered() {
      const giftsApi = new GiftsApi(this.logonToken)
      return giftsApi
        .getGiftsUserSurveysByType(this.survey.type)
        .then((surveys) => {
          if (surveys.length) return true
          return false
        })
        .catch(() => false)
    },
  },
}
</script>

<style lang="scss">
.modal-convincing-deactivating-list {
  .c-base-modal__wrapper {
    max-width: 707px;
    width: calc(100% - 30px);
    border-radius: 16px;
  }
}

.c-convincing-deactivating-list {
  padding: 56px 16px 40px;
  color: $neutral;
  @media screen and (min-width: 480px) {
    padding: 56px 40px 40px;
  }

  .title {
    max-width: 520px;
    margin: 0 auto 16px;
    font-size: 32px;
    font-weight: 900;
    color: $neutral;
  }

  .subtitle {
    margin: 0 auto 16px;
    font-size: 18px;
    color: $neutral;
    &.is-medium {
      font-size: 24px;
    }
    > strong {
      color: $neutral;
    }
  }

  .link {
    display: block;
    margin: 24px auto 0;
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
  }

  .benefits-list {
    display: block;
    max-width: 506px;
    margin: 34px auto;
    li {
      display: flex;
      align-items: center;
      margin-bottom: 28px;
      font-size: 16px;
      text-align: left;
      strong {
        color: $neutral;
      }
      .icon {
        color: $primary;
        margin-right: 16px;
        flex: none;
      }
    }
  }

  .button {
    font-size: 16px;
  }
}
</style>
